import { render, staticRenderFns } from "./Materials.vue?vue&type=template&id=10b9baca&scoped=true&"
import script from "./Materials.vue?vue&type=script&lang=ts&"
export * from "./Materials.vue?vue&type=script&lang=ts&"
import style0 from "./Materials.vue?vue&type=style&index=0&id=10b9baca&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10b9baca",
  null
  
)

export default component.exports